import React, { PureComponent } from 'react'
import { IRandomAssetData, FreezePosition } from '../../helpers/data/assetData'
import Asset from './Asset'
import shuffleArray from '../../helpers/arrayShuffler'

interface IRandomAssetProps {
	assetData: IRandomAssetData
	uid: string
	onAssetLoaded: () => void
	onComplete?: () => void
	areAnimationsEnabled?: boolean
	freezePosition?: FreezePosition
}

class RandomAsset extends PureComponent<IRandomAssetProps> {
	render() {
		const shuffledOptions = shuffleArray(this.props.uid + this.props.assetData.randomId, [
			...this.props.assetData.options,
		])

		return <Asset asset={shuffledOptions[0]} onLoad={this.props.onAssetLoaded} onComplete={this.props.onComplete} areAnimationsEnabled={this.props.areAnimationsEnabled} freezePosition={this.props.freezePosition} />
	}
}

export default RandomAsset
